import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import { ErrorsImageUnexpected } from 'teacher-ui-client/components/errors/image-unexpected'
import { ErrorsButtonHome } from 'teacher-ui-client/components/errors/button-home'

interface Signature {
  Element: HTMLDivElement
  Args: {
    compact?: boolean
  }
}

/**
 * Intended to be displayed when an unexpected errors is encountered.
 * Provides a compact mode for rendering inside other components/containers.
 *
 * If you know the error that is likely to occur, you should create or use another component with more detail instead of
 * using this one - or better yet, handle the error.
 */
export const ErrorsUnexpected: TOC<Signature> = <template>
  <div data-test-errors-unexpected class="text-dusty-black-300 space-y-2 text-center" ...attributes>
    {{#if @compact}}
      <ErrorsImageUnexpected class="max-w-28" />
      <p class="font-bold" data-test-unexpected-body>
        {{t "components.errors.unexpectedError.bodyCompact" htmlSafe=true}}
      </p>
    {{else}}
      <ErrorsImageUnexpected />
      <h2 data-test-unexpected-title>
        {{t "components.errors.unexpectedError.title"}}
      </h2>
      <p class="text-xl" data-test-unexpected-body>
        {{t "components.errors.unexpectedError.body" htmlSafe=true}}
      </p>
      <div class="p-2">
        <ErrorsButtonHome />
      </div>
    {{/if}}
  </div>
</template>
